export const CREATE_API_KEY = 'api/create-api-key';
export const CREATE_API_KEY_SUCCESS = 'api/create-api-key-success';
export const CREATE_API_KEY_FAIL = 'api/create-api-key-fail';
export const CREATE_API_KEY_RESET = 'api/create-api-key-reset';

export const UPDATE_API_KEY = 'api/update-api-key';
export const UPDATE_API_KEY_SUCCESS = 'api/update-api-key-success';
export const UPDATE_API_KEY_FAIL = 'api/update-api-key-fail';